import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/hand_peace.svg'


const _withScopeId = n => (_pushScopeId("data-v-25659844"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modalContent" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "my-4 py-2"
}
const _hoisted_6 = {
  key: 1,
  class: "text"
}
const _hoisted_7 = {
  key: 2,
  class: "w-100 mt-5"
}
const _hoisted_8 = {
  key: 3,
  class: "w-100 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_localized_text, {
          localizedKey: "app_Ooh yes!",
          text: "Ooh yes!",
          type: "h1"
        }),
        _createVNode(_component_localized_text, {
          localizedKey: "app_5 punti per te!",
          text: "5 punti per te!",
          type: "h1"
        }),
        (_ctx.totalMilliseconds > 0)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.timerValue), 1))
          : _createCommentVNode("", true),
        (_ctx.tooltipText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.tooltipText), 1))
          : _createCommentVNode("", true),
        (!_ctx.isFinished)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "btn btn-primary w-100 mb-4",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextChallenge()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_Prossima domanda",
                  text: "Prossima domanda"
                })
              ]),
              _createVNode(_component_localized_text, {
                localizedKey: "app_Continua dopo",
                text: "Continua dopo",
                class: "linkButton",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.backHome()))
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "btn btn-primary w-100 mb-4",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToRanking()))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_Classifica",
                  text: "Classifica"
                })
              ])
            ]))
      ])
    ])
  ]))
}